const dateInputStyle = {
  width: "100%",
  padding: "8px",
  border: "none",
  outline: "none",
  backgroundColor: "transparent",
  color: "var(--text-primary)",
  textAlign: "center",
  fontFamily: "Poppins, sans-serif",
  fontSize: "0.875rem",
  cursor: "pointer",
};

export const PickupDeadlineEditCell = (props) => {
  const { id, value, field, api } = props;
  const today = new Date().toISOString().split("T")[0];

  const handleChange = (event) => {
    const newValue = event.target.value ? new Date(event.target.value) : null;
    api.setEditCellValue({ id, field, value: newValue });
  };

  const formattedValue =
    value instanceof Date ? value.toISOString().split("T")[0] : "";

  return (
    <input
      type="date"
      value={formattedValue}
      onChange={handleChange}
      min={today}
      style={dateInputStyle}
    />
  );
};

export const ListingDateEditCell = (props) => {
  const { id, value, field, api } = props;
  const today = new Date().toISOString().split("T")[0];

  const handleChange = (event) => {
    const newValue = event.target.value ? new Date(event.target.value) : null;
    api.setEditCellValue({ id, field, value: newValue });
  };

  const formattedValue =
    value instanceof Date ? value.toISOString().split("T")[0] : "";

  return (
    <input
      type="date"
      value={formattedValue}
      onChange={handleChange}
      max={today}
      style={dateInputStyle}
    />
  );
};
